import classNames from 'classnames'
import React from 'react'

const Flex = ({ children, extraClass, flexWrap }) => (
  <div className={classNames('flex', extraClass, { 'flex-wrap': flexWrap })}>
    {children}
  </div>
)

export default Flex
